import { useCallback } from 'react';

import { useAuthentication } from 'commons/hooks';

import { COMPLETIONS_API, CompletionsRequest, CompletionsResponse } from './endpoints/completion';
import { IMAGE_API, ImageRequest, ImageResponse } from './endpoints/image';
import {
  IMAGE_VARIATIONS_API,
  ImageVariationsRequest,
  ImageVariationsResponse,
} from './endpoints/imageVariations';
import { MODIFY_TEXT_API, ModifyTextRequest, ModifyTextResponse } from './endpoints/modifyText';
import {
  TEMPLATE_CONTENT_URI,
  TemplateContent,
  TemplateContentRequest,
} from './endpoints/templateContent';
import {
  Suggestions,
  SuggestionsRequest,
  TEMPLATE_SUGGESTIONS_URI,
} from './endpoints/templateSuggestions';

export const useFirstMate = () => {
  const { customerId, signature } = useAuthentication();

  const firstMateApi = useCallback(
    <Request, Response>(endpoint: string) => async (
      data: Request,
    ): Promise<Response | undefined> => {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          userId: `${customerId}`,
          signature: `${signature}`,
        },
        body: JSON.stringify(data),
      });

      let json: Response;
      try {
        json = await res.json();
      } catch (e) {
        console.error(e);
        return undefined;
      }

      return json;
    },
    [customerId, signature],
  );

  if (!customerId || !signature) {
    return null;
  }

  return {
    completion: firstMateApi<CompletionsRequest, CompletionsResponse>(COMPLETIONS_API),
    image: firstMateApi<ImageRequest, ImageResponse>(IMAGE_API),
    imageVariations: firstMateApi<ImageVariationsRequest, ImageVariationsResponse>(
      IMAGE_VARIATIONS_API,
    ),
    modifyText: firstMateApi<ModifyTextRequest, ModifyTextResponse>(MODIFY_TEXT_API),
    templateSuggestions: firstMateApi<SuggestionsRequest, Suggestions>(TEMPLATE_SUGGESTIONS_URI),
    templateContent: firstMateApi<TemplateContentRequest, TemplateContent>(TEMPLATE_CONTENT_URI),
  };
};
